/* ═══════════════════════════════════════════════════════════════════════════════════════════════════════════
   BUILDER B · THE INSIDE COLOUR, DIRECTION C1 "FIRST IN LOOK" (Brief 22; Daniel, 13 Oct: "for builder inside color,
   I'm going with c1. important note - if the border has a design of any kind, we can't overlay it with a different
   color. if it doesn't, we can. develop but put it behind a switch. I want to show Yonatan before we make a decision.")

   The design: venture repo projects/pop-cards/design-brief/claude-design/reference/builder-22/claude-design-C1/.

   OFF AGAIN SINCE 2026-10-19 (see ON below). ON FOR CUSTOMERS FROM 2026-10-14 (Daniel, 14 Oct: "go"; Yonatan, #claude-communication p1791922171279759: no
   objection to solid colour on the plain surfaces, the fixed list of 18 is fine, light ink on dark is fine). The switch
   stays as an off-switch: ?ppinside=0 turns it off in this browser, ?ppinside=c1 back on (remembered like the other pp*
   switches, and by rememberSwitches in configurator.js when the builder sends the visitor away). Off, nothing here
   touches the page: the Look step's group is an x-if that never renders, no layer is ever made, and the order carries
   nothing.

   ⭐ IT REACHES THE ORDER (2026-10-14) as `_Inside Colour`, written by buildCartProperties below only when a colour
   other than Paper white is chosen on a design that offers the choice, and at least one surface takes it:
       "Night blue · #1C2441 · light ink · top, note, strip"
   the name and print value from LIST, the ink the words take, and the surfaces the customer saw coloured. Print
   (venture repo projects/pop-cards/print/inside-colour.mjs) fills exactly those surfaces, after checking each one is
   plain on the print master, and keeps the glue band bare. Contract: projects/pop-cards/docs/
   2026-09-08-order-property-contract.md, "The inside colour". Absent = the white inside every order had before.
   The chosen colour still lives on the component (insideKey) and in its own localStorage key, per design; draftFrom
   (an allowlist) adds nothing.

   WHAT IT DOES
   · The swatches: Claude Design's fixed list of 18 named colours (picturepops-inside.js in the C1 folder, a proposal
     for Yonatan to proof), each with its text colour already decided. The cover (the design's CoverFront art) is read
     once into a canvas, its pixels clustered into 8 colours in OKLab (k-means), each cluster snapped to the nearest
     list colour, areas summed per colour; anything that snaps to Paper white is dropped (it is always first), and so is
     anything under 2 % of the cover. The rest by area, up to five. Cached per cover (memory and sessionStorage).
   · Which surfaces take it (Daniel's rule, 13 Oct): only a surface whose art is PLAIN, i.e. blank. Each face's art is
     sampled once (640 px): it is blank when nothing but near-white or clear pixels is printed on it (under 0.05 % of
     the face may differ: a stray pixel at the bleed is not a design), and anything else is the artist's (a pattern,
     an illustration, a printed ground, a printed greeting) and is never overlaid. A blank face is recoloured flat;
     the customer's own words on a blank text-free inside top are recoloured through a canvas (the ground to the
     colour, the lettering to the swatch's ink on a dark swatch, coloured lettering lightened until it reads).
     The pop-up strip follows the design's photo border art (Part B, catalogue `Strip`); a design with no border art
     is plain paper. The inside top follows its art, or the text-free top under the customer's words; never the
     customer's photo. The note panel follows its printed ground; never while the design's own message is up.
     The control is offered when at least one surface can take a colour, and is not there at all (C1, "A design whose
     inside is the artist's art") when none can.
   · Legible writing: the note and the captions take the swatch's ink (--pp-color-ink on the plane); lettering inside
     the art is turned to the ink by the canvas on dark swatches.
   · Still paper: a neutral-grey paper tile blended by overlay over the colour (light flecks on dark stock, dark on
     light), as C1's "Still paper, still printed".
   ═══════════════════════════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  const PP = window.PP = window.PP || {};

  /* ⛔ OFF FOR CUSTOMERS SINCE 2026-10-19 (Daniel and Yonatan's sync: full-colour insides cost a lot of ink and press
     time on the in-house run; kept for when a print house prints). Off unless this browser was switched on:
     ?ppinside=1 (or c1) stores '1', ?ppinside=0 clears it. The same key and value rememberSwitches in configurator.js
     keeps across the builder's own redirects. A '0' left by the old off-switch reads as off, which it now is. Print
     still reads `_Inside Colour` when an order carries one. */
  const ON = (function () {
    try {
      const m = /[?&]ppinside=(c1|1|0)(?:&|$)/.exec(location.search);
      if (m) { if (m[1] === '0') localStorage.removeItem('pp_ppinside'); else localStorage.setItem('pp_ppinside', '1'); }
      return localStorage.getItem('pp_ppinside') === '1';
    } catch (e) { return /[?&]ppinside=(c1|1)(?:&|$)/.test(location.search); }
  })();

  /* Claude Design's print list (C1, picturepops-inside.js, 13 Oct; Yonatan, 14 Oct: "the fixed list of 18 is fine").
     Every swatch is a key from here, never a hex the cover throws up.
     ⛔ THE SAME TABLE IS `LIST` IN print/inside-colour.mjs (venture repo). Print refuses a name or a value that is not on
     its copy, and prints that card white inside, so a change here is a change there in the same change. */
  const LIST = {
    paper: { name: 'Paper white', hex: '#F8F6F1', ink: 'dark' },
    cream: { name: 'Cream', hex: '#EFE3C8', ink: 'dark' },
    blush: { name: 'Blush', hex: '#F0D8D2', ink: 'dark' },
    peach: { name: 'Peach', hex: '#EFC9A2', ink: 'dark' },
    sage: { name: 'Sage', hex: '#CDD5B8', ink: 'dark' },
    sky: { name: 'Pale sky', hex: '#D3DCE6', ink: 'dark' },
    stone: { name: 'Stone grey', hex: '#D5D2CC', ink: 'dark' },
    honey: { name: 'Honey gold', hex: '#CBAC5A', ink: 'dark' },
    marigold: { name: 'Marigold', hex: '#DEA44C', ink: 'dark' },
    dusk: { name: 'Dusk blue', hex: '#455371', ink: 'light' },
    olive: { name: 'Olive', hex: '#4E5624', ink: 'light' },
    flamingo: { name: 'Flamingo red', hex: '#9F1C43', ink: 'light' },
    brick: { name: 'Brick', hex: '#8F3626', ink: 'light' },
    leaf: { name: 'Leaf green', hex: '#3D5620', ink: 'light' },
    pine: { name: 'Pine', hex: '#1F3A1E', ink: 'light' },
    night: { name: 'Night blue', hex: '#1C2441', ink: 'light' },
    charcoal: { name: 'Charcoal', hex: '#34312D', ink: 'light' },
    ink: { name: 'Ink black', hex: '#161616', ink: 'light' },
  };
  const INK = { dark: '#1B2433', light: '#F8F6F1' };
  const MAX_SW = 5;          // cover colours shown after Paper white (C1's rule keeps four; the brief asked for 4-6)
  const MIN_AREA = 0.02;     // C1: "drop clusters under 2% of the cover"

  /* ── colour ─────────────────────────────────────────────────────────────────────────────────────────────── */
  const rgbOf = (h) => [1, 3, 5].map((i) => parseInt(h.substr(i, 2), 16));
  const lin = (c) => { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
  function oklab(r, g, b) {
    r = lin(r); g = lin(g); b = lin(b);
    const l = Math.cbrt(0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b);
    const m = Math.cbrt(0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b);
    const s = Math.cbrt(0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b);
    return [0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s, 1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s,
      0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s];
  }
  const KEYS = Object.keys(LIST);
  const LAB = KEYS.map((k) => oklab.apply(null, rgbOf(LIST[k].hex)));
  const d2 = (a, b) => (a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]) + (a[2] - b[2]) * (a[2] - b[2]);
  /* Nearest on the list, hue first: OKLab with the lightness and chroma differences at 0.6 and the hue difference at 2.5.
     Plain OKLab distance is ruled by lightness, so a mid yellow-green leaf (White Water Lily) went to Honey gold rather
     than a green, and the list has few mid tones to catch it; weighted, the six Brief 22 covers come out close to
     Claude Design's own picks (output/2026-10-13-inside-colour-c1/palette-test.mjs). */
  const LCH = LAB.map((q) => Math.hypot(q[1], q[2]));
  function nearest(lab) {
    const C = Math.hypot(lab[1], lab[2]);
    let bi = 0, bd = Infinity;
    for (let i = 0; i < LAB.length; i++) {
      const q = LAB[i], dL = lab[0] - q[0], dC = C - LCH[i], dH2 = Math.max(0, (lab[1] - q[1]) * (lab[1] - q[1]) + (lab[2] - q[2]) * (lab[2] - q[2]) - dC * dC);
      const v = 0.36 * dL * dL + 0.36 * dC * dC + 6.25 * dH2;
      if (v < bd) { bd = v; bi = i; }
    }
    return KEYS[bi];
  }
  const relLum = (c) => 0.2126 * lin(c[0]) + 0.7152 * lin(c[1]) + 0.0722 * lin(c[2]);
  const contrast = (a, b) => { const x = relLum(a), y = relLum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); };

  /* ── images ─────────────────────────────────────────────────────────────────────────────────────────────── */
  function loadImg(src) {
    return new Promise((ok, no) => {
      const im = new Image();
      if (!/^blob:|^data:/.test(src)) im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = () => ok(im);
      im.onerror = () => no(new Error('img'));
      im.src = src;
    });
  }
  function pixels(im, maxW) {
    const W = Math.max(1, Math.min(maxW, im.naturalWidth)), H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0, W, H);
    const d = x.getImageData(0, 0, W, H).data;
    c.width = c.height = 0;
    return { W, H, d };
  }
  // A cache that survives the tab's reloads (palettes and classifications are small; a "no" from a failed read is not kept).
  function sessionCache(name) {
    const M = new Map();
    let saved = {};
    try { saved = JSON.parse(sessionStorage.getItem(name) || '{}'); } catch (e) { saved = {}; }
    return {
      get(k) { if (M.has(k)) return M.get(k); if (saved[k] !== undefined) return Promise.resolve(saved[k]); return undefined; },
      set(k, p) {
        M.set(k, p);
        p.then((v) => { if (v == null) return; saved[k] = v; try { sessionStorage.setItem(name, JSON.stringify(saved)); } catch (e) { /* full: memory only */ } },
          () => { M.delete(k); });
        return p;
      },
    };
  }
  const keyOf = (src) => String(src || '').replace(/[?#].*$/, '') + (/[?&]v=([^&#]+)/.exec(src || '') || ['', ''])[1];

  /* ── the cover's palette (C1's rule) ───────────────────────────────────────────────────────────────────── */
  const PAL = sessionCache('pp_inside_pal_v2');
  function palette(src) {
    if (!src) return Promise.resolve([]);
    const k = keyOf(src), hit = PAL.get(k);
    if (hit) return hit;
    return PAL.set(k, loadImg(src).then((im) => {
      const { W, H, d } = pixels(im, 160);
      const pts = [];
      for (let i = 0; i < W * H; i++) { if (d[i * 4 + 3] < 128) continue; pts.push(oklab(d[i * 4], d[i * 4 + 1], d[i * 4 + 2])); }
      if (!pts.length) return [];
      // k-means, 8 clusters, seeded by farthest point from the mean (deterministic: the same cover, the same swatches)
      const K = Math.min(8, pts.length), C = [];
      const mean = [0, 0, 0]; pts.forEach((p) => { mean[0] += p[0]; mean[1] += p[1]; mean[2] += p[2]; });
      mean[0] /= pts.length; mean[1] /= pts.length; mean[2] /= pts.length;
      const far = (ref) => { let bi = 0, bd = -1; pts.forEach((p, i) => { const v = Math.min.apply(null, ref.map((r) => d2(p, r))); if (v > bd) { bd = v; bi = i; } }); return pts[bi].slice(); };
      C.push(far([mean]));
      while (C.length < K) C.push(far(C));
      const asg = new Int16Array(pts.length);
      for (let it = 0; it < 12; it++) {
        pts.forEach((p, i) => { let bi = 0, bd = Infinity; for (let j = 0; j < C.length; j++) { const v = d2(p, C[j]); if (v < bd) { bd = v; bi = j; } } asg[i] = bi; });
        const S = C.map(() => [0, 0, 0, 0]);
        pts.forEach((p, i) => { const s = S[asg[i]]; s[0] += p[0]; s[1] += p[1]; s[2] += p[2]; s[3]++; });
        S.forEach((s, j) => { if (s[3]) C[j] = [s[0] / s[3], s[1] / s[3], s[2] / s[3]]; });
      }
      const area = {};
      const n = C.map(() => 0); for (let i = 0; i < pts.length; i++) n[asg[i]]++;
      C.forEach((c, j) => { const key = nearest(c); area[key] = (area[key] || 0) + n[j] / pts.length; });
      return Object.keys(area).filter((key) => key !== 'paper' && area[key] >= MIN_AREA)
        .sort((a, b) => area[b] - area[a]).slice(0, MAX_SW)
        .map((key) => ({ key, area: +area[key].toFixed(3) }));
    }));
  }

  /* ── is a surface plain? ────────────────────────────────────────────────────────────────────────────────── */
  const CLS = sessionCache('pp_inside_cls_v3');
  // 'blank' | 'art', and the numbers for the log (cov: the share of the face printed; neutral: how much of that is black or grey)
  function classify(src) {
    if (!src) return Promise.resolve({ k: 'blank', cov: 0, neutral: 1, none: true });
    const k = keyOf(src), hit = /^blob:|^data:/.test(src) ? undefined : CLS.get(k);
    if (hit) return hit;
    const p = loadImg(src).then((im) => {
      // Fine enough to see a border's small stars (Gemini's: 1.4 % of the strip at this size, gone into the white at 220 px).
      const { W, H, d } = pixels(im, 640);
      let marks = 0, ink = 0, neutral = 0, inkTone = 0;
      for (let i = 0; i < W * H; i++) {
        const a = d[i * 4 + 3] / 255;
        const r = d[i * 4] * a + 255 * (1 - a), g = d[i * 4 + 1] * a + 255 * (1 - a), b = d[i * 4 + 2] * a + 255 * (1 - a);
        const mn = Math.min(r, g, b), sp = Math.max(r, g, b) - mn;
        if (mn >= 240 && sp <= 14) continue;          // white or clear: the paper (stricter than card-paper.js's mask)
        marks++;
        const A = (255 - mn) / 255;                     // how much was printed here
        const t = [255 - (255 - r) / A, 255 - (255 - g) / A, 255 - (255 - b) / A];
        ink += A;
        if (Math.max(t[0], t[1], t[2]) - Math.min(t[0], t[1], t[2]) < 48) { neutral += A; inkTone += A * (t[0] + t[1] + t[2]) / 3; }
      }
      const cov = marks / (W * H), nShare = ink ? neutral / ink : 1;
      const out = { cov: +cov.toFixed(4), neutral: +nShare.toFixed(3), tone: neutral ? Math.round(inkTone / neutral) : null };
      // A speck or two (a stray pixel at the bleed) is not a design; 0.05 % of the face is (Daniel: "a design of any kind").
      if (cov < 0.0005) out.k = 'blank';
      // Whatever the design printed is the artist's, lettering included: a greeting set beside a small drawing reads as
      // "words" by any pixel rule and is still their art (Whos Afraid, 13 Oct). Never overlaid. The numbers stay for the log.
      else out.k = 'art';
      out.lettering = cov < 0.14 && nShare >= 0.9;
      return out;
    });
    return /^blob:|^data:/.test(src) ? p : CLS.set(k, p);
  }

  /* ── the recoloured face: the ground to the swatch, neutral lettering to its ink on a dark swatch ───────── */
  const RC = new Map();   // src|key -> Promise<blob URL>
  function recolour(src, key) {
    const id = src + '|' + key;
    if (RC.has(id)) return RC.get(id);
    const L = LIST[key], S = rgbOf(L.hex), LI = rgbOf(INK.light), dark = L.ink === 'light';
    const p = loadImg(src).then((im) => new Promise((ok) => {
      const scale = Math.min(1, 1400 / Math.max(im.naturalWidth, im.naturalHeight));
      const W = Math.round(im.naturalWidth * scale), H = Math.round(im.naturalHeight * scale);
      const c = document.createElement('canvas'); c.width = W; c.height = H;
      const x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(im, 0, 0, W, H);
      const img = x.getImageData(0, 0, W, H), d = img.data, memo = new Map();
      for (let i = 0; i < d.length; i += 4) {
        const a = d[i + 3] / 255;
        const r = d[i] * a + 255 * (1 - a), g = d[i + 1] * a + 255 * (1 - a), b = d[i + 2] * a + 255 * (1 - a);
        const A = (255 - Math.min(r, g, b)) / 255;
        let t;
        if (A < 0.004) t = S;
        else {
          t = [255 - (255 - r) / A, 255 - (255 - g) / A, 255 - (255 - b) / A];
          if (dark) {
            const q = ((t[0] >> 3) << 10) | ((t[1] >> 3) << 5) | (t[2] >> 3);
            let u = memo.get(q);
            if (!u) {
              if (Math.max(t[0], t[1], t[2]) - Math.min(t[0], t[1], t[2]) < 48) u = LI;
              else { u = t; for (let m = 0.25; m <= 1 && contrast(u, S) < 3; m += 0.25) u = [t[0] + (LI[0] - t[0]) * m, t[1] + (LI[1] - t[1]) * m, t[2] + (LI[2] - t[2]) * m]; }
              memo.set(q, u);
            }
            t = u;
          }
        }
        d[i] = S[0] + (t[0] - S[0]) * A; d[i + 1] = S[1] + (t[1] - S[1]) * A; d[i + 2] = S[2] + (t[2] - S[2]) * A; d[i + 3] = 255;
      }
      x.putImageData(img, 0, 0);
      c.toBlob((bl) => { c.width = c.height = 0; ok(bl ? URL.createObjectURL(bl) : ''); }, 'image/png');
    })).catch(() => '');
    RC.set(id, p);
    if (RC.size > 40) { const first = RC.keys().next().value; const old = RC.get(first); RC.delete(first); old.then((u) => { if (u) setTimeout(() => URL.revokeObjectURL(u), 5000); }); }
    return p;
  }

  /* ── the paper on the colour: a neutral-grey tile (50 % grey changes nothing under overlay), so it reads on any
        swatch: lighter fibres and tooth show on dark stock, darker on light. Drawn once, seeded. ─────────────────── */
  let texDone = false;
  function texture() {
    if (texDone) return; texDone = true;
    try {
      const T = 256, c = document.createElement('canvas'); c.width = c.height = T;
      const x = c.getContext('2d'), im = x.createImageData(T, T), p = im.data;
      let s = 0x2f6b9e11;
      const rnd = () => { s = (s + 0x6D2B79F5) | 0; let t = Math.imul(s ^ (s >>> 15), 1 | s); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
      const n = 8, L = new Float32Array(n * n).map(() => rnd() * 2 - 1);
      const smooth = (i, y) => { const fx = i * n / T, fy = y * n / T, ix = fx | 0, iy = fy | 0, tx = fx - ix, ty = fy - iy, sx = tx * tx * (3 - 2 * tx), sy = ty * ty * (3 - 2 * ty);
        const a = L[(iy % n) * n + ix % n], b = L[(iy % n) * n + (ix + 1) % n], cc = L[((iy + 1) % n) * n + ix % n], dd = L[((iy + 1) % n) * n + (ix + 1) % n];
        return a + (b - a) * sx + (cc - a) * sy + (a - b - cc + dd) * sx * sy; };
      for (let y = 0; y < T; y++) for (let i = 0; i < T; i++) {
        const v = 128 + 5 * smooth(i, y) + 9 * (rnd() * 2 - 1), k = (y * T + i) * 4;
        p[k] = p[k + 1] = p[k + 2] = v; p[k + 3] = 255;
      }
      x.putImageData(im, 0, 0);
      x.lineCap = 'round';
      for (let f = 0; f < 140; f++) {
        const x0 = rnd() * T, y0 = rnd() * T, a = rnd() * Math.PI * 2, len = 4 + rnd() * 14, light = rnd() < 0.6;
        x.strokeStyle = light ? 'rgba(255,255,255,' + (0.18 + rnd() * 0.2).toFixed(2) + ')' : 'rgba(0,0,0,' + (0.12 + rnd() * 0.14).toFixed(2) + ')';
        x.lineWidth = 0.6 + rnd() * 0.6;
        x.beginPath(); x.moveTo(x0, y0); x.lineTo(x0 + Math.cos(a) * len, y0 + Math.sin(a) * len); x.stroke();
      }
      c.toBlob((b) => { if (b) document.documentElement.style.setProperty('--ppi-tex', 'url("' + URL.createObjectURL(b) + '")'); c.width = c.height = 0; }, 'image/png');
    } catch (e) { /* no canvas: the flat colour */ }
  }

  PP.inside = { ON, LIST, INK, palette, classify, recolour, contrast: (a, b) => contrast(rgbOf(a), rgbOf(b)) };

  /* ── the component ─────────────────────────────────────────────────────────────────────────────────────── */
  if (typeof PP.builderB !== 'function') return;
  const inner = PP.builderB;
  const PICK_KEY = 'pp_inside_pick';     // { designId: listKey } — this browser only, never the order
  const readPicks = () => { try { return JSON.parse(localStorage.getItem(PICK_KEY) || '{}') || {}; } catch (e) { return {}; } };

  PP.builderB = function () {
    const c = inner.apply(this, arguments);

    Object.assign(c, {
      insideKey: 'paper',
      insideInfo: null,      // { id, sw: [{key, area}], top, bottom, strip, thumb } for the chosen design, once read
      insideOn() { return ON; },
      // The design's surfaces that can take a colour right now, by name.
      insidePlain() {
        const I = this.insideInfo, d = this.card && this.card.design;
        if (!I || !d || I.id !== d.id) return {};
        const ok = (cl) => !!cl && cl.k === 'blank';
        let top = false;
        try { top = !(this.topActive() && this.topMode() === 'photo') && ok(this.topActive() ? I.topPlain : I.top); } catch (e) { top = ok(I.top); }
        let msg = false; try { msg = this.showDesignMessage(); } catch (e) { msg = false; }
        return { top, bottom: !msg && ok(I.bottom), strip: !!I.strip && I.strip.k === 'blank' };
      },
      insideOffered() {
        if (!ON || this.stage !== 'builder') return false;
        const I = this.insideInfo, d = this.card && this.card.design;
        if (!I || !d || I.id !== d.id || !I.sw.length) return false;
        // Offered when one surface of the design can take it (C1: no control at all when the inside is the artist's art).
        const ok = (cl) => !!cl && cl.k === 'blank';
        return ok(I.top) || ok(I.topPlain) || ok(I.bottom) || (!!I.strip && I.strip.k === 'blank');
      },
      insideSwatches() {
        const I = this.insideInfo, self = this;
        if (!I) return [];
        return ['paper'].concat(I.sw.map((s) => s.key)).map(function (k) {
          const L = LIST[k];
          return { key: k, name: L.name, hex: L.hex, dark: L.ink === 'light', on: self.insideKey === k,
                   aria: k === 'paper' ? 'Paper white, as today' : L.name + ', from the cover' };
        });
      },
      insideName() { const k = this.insideKey; return k === 'paper' ? 'Paper white' : LIST[k].name + ', from the cover'; },
      /* The order's `_Inside Colour`, or '' for white (contract: "The inside colour"). The surfaces are the ones this
         preview colours right now (insidePlain): the inside top, the note panel (`note`), the strip; never the strip at
         the None border, where the photo covers the whole panel. */
      insideProperty() {
        if (!this.insideOffered()) return '';
        const k = this.insideKey, L = LIST[k];
        if (!L || k === 'paper') return '';
        const P = this.insidePlain(), border = this.card && this.card.border;
        const on = [];
        if (P.top) on.push('top');
        if (P.bottom) on.push('note');
        if (P.strip && border !== 'none') on.push('strip');
        if (!on.length) return '';
        return L.name + ' · ' + L.hex + ' · ' + (L.ink === 'light' ? 'light' : 'dark') + ' ink · ' + on.join(', ');
      },
      insideThumb() { return (this.insideInfo && this.insideInfo.thumb) || ''; },
      insideThumbFlip() { return !!(this.insideInfo && this.insideInfo.thumbFlip); },
      insidePick(k) {
        if (!LIST[k] || !this.card || !this.card.design) return;
        this.insideKey = k;
        const p = readPicks();
        if (k === 'paper') delete p[this.card.design.id]; else p[this.card.design.id] = k;
        try { localStorage.setItem(PICK_KEY, JSON.stringify(p)); } catch (e) { /* this visit only */ }
      },
      // Arrow keys move along the radio group, as a radio group does (Home / End to the ends).
      insideKeyNav(e) {
        const keys = this.insideSwatches().map((s) => s.key), i = keys.indexOf(this.insideKey);
        let j = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % keys.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + keys.length) % keys.length;
        else if (e.key === 'Home') j = 0; else if (e.key === 'End') j = keys.length - 1;
        if (j < 0) return;
        e.preventDefault();
        this.insidePick(keys[j]);
        const box = e.currentTarget;
        this.$nextTick(() => { const b = box && box.querySelectorAll('[role="radio"]')[j]; if (b) b.focus({ preventScroll: true }); });
      },
    });

    /* ⭐ THE ORDER (2026-10-14): one property beside the rest, only when there is a colour to print. */
    const baseBuild = c.buildCartProperties;
    if (typeof baseBuild === 'function') {
      c.buildCartProperties = function () {
        const props = baseBuild.apply(this, arguments);
        let v = '';
        try { v = ON ? this.insideProperty() : ''; } catch (e) { v = ''; }
        if (v && props && typeof props === 'object') props['_Inside Colour'] = v;
        return props;
      };
    }

    const baseInit = c.init;
    c.init = function () {
      const out = baseInit.apply(this, arguments);
      if (ON) start(this);
      return out;
    };
    return c;
  };

  /* ── reading a design, and laying the colour on the 3D card ───────────────────────────────────────────── */
  function start(self) {
    texture();
    let readFor = null, t = 0;
    const later = () => { clearTimeout(t); t = setTimeout(() => apply(self), 20); };

    function read(d) {
      if (!d || !d.id || readFor === d.id) return;
      readFor = d.id;
      const id = d.id;
      const cat = (self.designs || []).filter((x) => x.id === id)[0];
      // The tile's own picture (design-picker.js designClosedUrl: the closed shot, resolved for theme designs too).
      let closed = '';
      try { closed = cat && self.designHasClosedShot(cat) ? self.designClosedUrl(cat) : ''; } catch (e) { closed = ''; }
      Promise.all([
        palette(d.CoverFront).catch(() => []),
        classify(d.CoverTop).catch(() => null),
        d.CoverTopPlain ? classify(d.CoverTopPlain).catch(() => null) : Promise.resolve(null),
        d.CoverBottomGround ? classify(d.CoverBottomGround).catch(() => null) : Promise.resolve({ k: 'blank', none: true }),
        d.Strip ? classify(d.Strip).catch(() => null) : Promise.resolve({ k: 'blank', none: true }),
      ]).then(([sw, top, topPlain, bottom, strip]) => {
        if (!self.card.design || self.card.design.id !== id) return;
        self.insideInfo = { id, sw, top, topPlain, bottom, strip, thumb: closed || d.CoverFront, thumbFlip: !closed };
        const k = readPicks()[id];
        self.insideKey = k && (k === 'paper' || sw.some((s) => s.key === k)) ? k : 'paper';
        try { console.info('[ppinside]', id, d.name, JSON.stringify({ sw: sw.map((s) => s.key + ' ' + s.area), top: top && top.k, topPlain: topPlain && topPlain.k, bottom: bottom && bottom.k, strip: strip && strip.k })); } catch (e) { /* no console */ }
        later();
      });
    }

    const go = () => {
      if (!window.Alpine || !Alpine.effect) return setTimeout(go, 100);
      Alpine.effect(() => {
        const d = self.card && self.card.design;
        void (d && d.id); void self.insideKey; void self.insideInfo; void self.topPreviewUrl; void self.card.border; void self.stage;
        try { self.topMode(); self.topActive(); self.showDesignMessage(); } catch (e) { /* not offered */ }
        if (d) read(d);
        later();
      });
    };
    go();
  }

  function stageEl() { return document.querySelector('[data-builder-ui] [data-pp-stage]') || document.querySelector('[data-pp-stage]'); }
  function layer(plane, after, z) {
    let el = plane.querySelector(':scope > .ppi-layer');
    if (!el) {
      el = document.createElement('span');
      el.className = 'ppi-layer'; el.setAttribute('aria-hidden', 'true');
      if (z != null) el.style.zIndex = z;
      if (after && after.parentNode === plane) after.after(el); else plane.appendChild(el);
    }
    return el;
  }
  function clearPlane(plane) {
    if (!plane) return;
    const el = plane.querySelector(':scope > .ppi-layer');
    if (el) { el.hidden = true; el.removeAttribute('data-for'); el.style.backgroundImage = ''; el.style.backgroundColor = ''; }
    plane.classList.remove('ppi-on', 'ppi-dark');
    plane.style.removeProperty('--pp-color-ink');
  }
  function dressPlane(plane, key) {
    const L = LIST[key];
    plane.classList.add('ppi-on');
    plane.classList.toggle('ppi-dark', L.ink === 'light');
    if (L.ink === 'light') plane.style.setProperty('--pp-color-ink', INK.light); else plane.style.removeProperty('--pp-color-ink');
  }
  // A face: flat colour when its art is blank, the recoloured art when it carries lettering.
  function face(el, key, src, cls) {
    const L = LIST[key], tag = key + '|' + (cls === 'words' ? src : 'flat');
    if (el.getAttribute('data-for') === tag && !el.hidden) return;
    el.setAttribute('data-for', tag);
    el.style.backgroundColor = L.hex;
    if (cls !== 'words') { el.style.backgroundImage = 'var(--ppi-tex, none)'; el.hidden = false; return; }
    recolour(src, key).then((u) => {
      if (el.getAttribute('data-for') !== tag) return;
      el.style.backgroundImage = 'var(--ppi-tex, none), ' + (u ? 'url("' + u + '")' : 'none');
      el.hidden = false;
    });
  }

  function apply(self) {
    const stage = stageEl();
    if (!stage) return;
    const plane = (n) => stage.querySelector('[data-pp-plane="' + n + '"]');
    const top = plane('CoverTop'), note = plane('CoverBottom');
    const panels = [].slice.call(stage.querySelectorAll('.pp-plane--panel[data-pp-panel]'));
    const key = self.insideKey, d = self.card && self.card.design;
    const on = self.insideOffered() && key && key !== 'paper' && LIST[key];
    stage.toggleAttribute('data-ppi', !!on);
    if (!on) { [top, note].concat(panels).forEach(clearPlane); return; }
    const P = self.insidePlain(), I = self.insideInfo;

    // The inside top: its art, or the customer's words on the text-free top (topPreviewUrl through designArt).
    if (top && P.top) {
      const src = self.designArt('CoverTop'), active = (function () { try { return self.topActive(); } catch (e) { return false; } })();
      const cls = active ? 'words' : (I.top && I.top.k);
      dressPlane(top, key);
      face(layer(top, top.querySelector(':scope > .rdf-paper')), key, src, cls);
    } else clearPlane(top);

    // The note panel: its printed ground (the note itself is HTML and takes the ink through --pp-color-ink).
    if (note && P.bottom) {
      dressPlane(note, key);
      const el = layer(note, note.querySelector(':scope > .rdf-paper'), 0);
      face(el, key, d.CoverBottomGround, I.bottom && I.bottom.k);
    } else clearPlane(note);

    // The pop-up strip: only a blank border (Daniel, 13 Oct). Under the photo, over the panel's own paper.
    panels.forEach((pl) => {
      if (!P.strip) { clearPlane(pl); return; }
      dressPlane(pl, key);
      const el = layer(pl, pl.querySelector(':scope > .rdf-paper'), -1);
      face(el, key, '', 'blank');
    });
  }
})();
